<template>
  <div
    class="location-picker"
    v-if="$store && $store.state && $store.state.ref"
  >
    <div class="form-group row">
      <label for="country" :class="`form-label col-md-${labelGridLength}`">Country *</label>
      <div :class="`col-md-${controlGridLength}`">
        <select
          class="form-control"
          id="country"
          @change="onCountryChanged"
          v-model="$v.formData.country.$model"
          required
          :class="{
            'is-invalid': $v.formData.country.$error,
            'is-valid':
              $v.formData.country.$error == false &&
              $v.formData.country.$model != '',
          }"
        >
          <option
            v-for="country in $store.state.ref.countries"
            :key="country.id"
            :value="country.id"
            :selected="country.id === formData.country"
          >
            {{ country.title }}
          </option>
        </select>
        <div class="invalid-feedback">Please select a Country.</div>
      </div>
    </div>
    <div
      class="form-group row"
      v-if="regions && regions.length > 0 && formData.country"
    >
      <label for="region" :class="`form-label col-md-${labelGridLength}`">Region *</label>
      <div :class="`col-md-${controlGridLength}`">
        <select class="form-control" id="region" @change="onRegionChanged">
          <option
            v-for="region in regions"
            :key="region.id"
            :value="region.id"
            :selected="region.id === formData.region"
          >
            {{ region.title }}
          </option>
        </select>
        <div class="invalid-feedback">Please select a Region.</div>
      </div>
    </div>
    <div
      class="form-group row"
      v-if="districts && districts.length > 0 && formData.region"
    >
      <label for="city" :class="`form-label col-md-${labelGridLength}`">City/District</label>
      <div :class="`col-md-${controlGridLength}`">
        <select class="form-control" id="district" @change="onDistrictChanged">
          <option
            v-for="district in districts"
            :key="district.id"
            :value="district.id"
            :selected="district.id === formData.district"
          >
            {{ district.title }}
          </option>
        </select>
        <div class="invalid-feedback">Please select a City/District.</div>
      </div>
    </div>
  </div>
</template>

<script>
import { required } from "vuelidate/lib/validators";

export default {
  props: {
    labelGridLength: {
      type: Number,
      default: 2
    },
    controlGridLength: {
      type: Number,
      default: 10
    }
  },
  data() {
    return {
      regions: [],
      districts: [],
      formData: {
        country: null,
        region: null,
        district: null,
      },
    };
  },
  validations: {
    formData: {
      country: {
        required,
      },
    },
  },
  methods: {
    async revalidate(model) {
      if (!model.country) {
        this.formData.country = null;
        this.formData.region = null;
        this.formData.district = null;
        return;
      }
      this.formData.country = model.country;
      this.regions = await this.$repo.ref.getLocationsByParentId(model.country);
      if (model.region) {
        this.formData.region = model.region;
        this.districts = await this.$repo.ref.getLocationsByParentId(model.region);
        this.formData.district = model.district;
      }
    },
    async onCountryChanged(e) {
      this.formData.region = null;
      this.formData.district = null;
      this.regions = [];
      this.districts = [];

      this.formData.country = e.target.value;
      if (!this.formData.country) return;

      this.regions = await this.$repo.ref.getLocationsByParentId(
        this.formData.country
      );

      if (this.regions && this.regions.length > 0) {
        this.onRegionChanged({ target: { value: this.regions[0].id } });
      } else {
        this.emitChange();
      }
    },
    async onRegionChanged(e) {
      this.formData.district = null;
      this.districts = [];

      this.formData.region = e.target.value;
      if (!this.formData.region) return;

      this.districts = await this.$repo.ref.getLocationsByParentId(
        this.formData.region
      );

      if (this.districts && this.districts.length > 0) {
        this.onDistrictChanged({ target: { value: this.districts[0].id } });
      } else {
        this.emitChange();
      }
    },
    async onDistrictChanged(e) {
      this.formData.district = e.target.value;
      this.emitChange();
    },
    emitChange() {
      this.$emit("change", this.formData);
    },
  },
};
</script>